import type { TypedReadSchema, TypedReadSchemaItem } from '@common/formEngine/typedReadSchema.types';
import type { TherapielandProgramSelectionFields } from '../osasConsultSchemas/types';
import type { OsasTreatmentBreakData, OsasTreatmentData } from './types';

export type TreatmentOptionKey = 'CPAP' | 'MRA' | 'SPT' | 'lifestyle' | 'other' | 'refer';

export const treatmentOptionsLabels: Record<TreatmentOptionKey, string> = {
    CPAP: 'CPAP',
    MRA: 'MRA',
    SPT: 'SPT',
    lifestyle: 'Advies leefstijl verandering',
    other: 'Anders',
    refer: 'Doorverwijzen',
};

export type OsasPolicyReadItemsReadKey =
    | keyof OsasTreatmentData
    | keyof TherapielandProgramSelectionFields
    | 'taskFollowingConsultWeeks';

export type OsasTreatmentChoiceReadKey = OsasPolicyReadItemsReadKey | keyof OsasTreatmentBreakData | 'remarkOther';

export type OsasTreatmentChoiceReadLabel =
    | 'Advies aan de huisarts'
    | 'Afbreken; therapie beëindigen'
    | 'Behandeling'
    | 'CPAP instellingen'
    | 'E-health programma´s'
    | 'Herzend Ksyos vragenlijsten na'
    | 'Herzend Ksyos vragenlijsten'
    | 'Overige opmerkingen'
    | 'Vervolg consult'
    | 'Vervolg slaaponderzoek'
    | 'Vervolgonderzoek na'
    | 'Vervolgconsult na'
    | 'Taak voor Ksyos Poli'
    | 'Toelichting behandeling'
    | 'Toelichting'
    | 'Doorverwijzen aan';

export type OsasTreatmentChoiceReadSectionTitle = 'Huidig beleid' | 'Beleid';

export const osasPolicyReadItems: TypedReadSchemaItem<OsasPolicyReadItemsReadKey, OsasTreatmentChoiceReadLabel>[] = [
    { key: 'treatment', label: 'Behandeling' },
    { key: 'refer', label: 'Doorverwijzen aan' },
    { key: 'shouldHaveFollowUpConsult', label: 'Vervolg consult' },
    { key: 'shouldHaveFollowingExamination', label: 'Vervolg slaaponderzoek' },
    {
        append: 'weken',
        key: 'taskFollowingExaminationOrConsultWeeks',
        label: 'Vervolgonderzoek na',
        type: 'number',
    },
    { key: 'cpapSetting', label: 'CPAP instellingen' },
    { key: 'cpapSettingText', label: 'CPAP instellingen' },
    { key: 'remarkTreatment', label: 'Toelichting behandeling' },
    { key: 'taskForPoliclinic', label: 'Taak voor Ksyos Poli' },
    { key: 'checkedTreatments', label: 'E-health programma´s' },
    { key: 'resendQuestionnaires', label: 'Herzend Ksyos vragenlijsten', type: 'boolean' },
    {
        append: 'weken',
        key: 'resendQuestionnairesWeeks',
        label: 'Herzend Ksyos vragenlijsten na',
        type: 'number',
    },
    { key: 'adviceGeneralPractitionerForOsa', label: 'Advies aan de huisarts' },
];

export const osasTreatmentChoiceReadSchema: TypedReadSchema<
    OsasTreatmentChoiceReadKey,
    OsasTreatmentChoiceReadLabel,
    OsasTreatmentChoiceReadSectionTitle
>[] = [
    {
        items: [
            { key: 'treatmentToBreak', label: 'Afbreken; therapie beëindigen' },
            { key: 'treatmentToBreakRemark', label: 'Toelichting' },
        ],
        sectionTitle: 'Huidig beleid',
    },
    {
        items: [...osasPolicyReadItems, { key: 'remarkOther', label: 'Overige opmerkingen' }],
        sectionTitle: 'Beleid',
    },
];
